import * as React from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	ButtonGroup,
	Icon,
	Modal,
	ModalActions,
	ModalContent,
	ModalHeader,
	Popup,
	Segment
} from "semantic-ui-react";
import {translate} from "react-i18next";
import {Subbar, SubItem, Title, PageHeader, Sortable, SearchFilter} from "ah-tools";
import Placeholder from "./Placeholder";
import {COLOR_PRIMARY} from "../misc/vars";
import {filterObj, processData, tryable} from 'ah-lib';
import WorkTimeController from "../containers/WorkTimeController";
import {
	Checkbox,
	Divider,
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow, TableRowColumn
} from "material-ui";
import VirtualList from "react-tiny-virtual-list";
import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import {PriceInfo} from "./WorkTime";
import {sort, sortDefault, sortNum} from "ith-sort";
import {compare, compareDefault} from "ith-compare";
import DetailedFilters from "../misc/DetailedFilters";
import {ResizableBox} from "react-resizable";
import 'react-resizable/css/styles.css';
import isNum from 'lodash/isNumber';
import {IconButton} from "../extensions";

const sortOptions = [
	{key: 'hsn-tsn-asc', order: 'ascending', title: 'HSN/TSN aufsteigend'},
	{key: 'hsn-tsn-desc', order: 'descending', title: 'HSN/TSN absteigend'},
	{key: 'type-asc', order: 'ascending', title: 'Typ aufsteigend'},
	{key: 'type-desc', order: 'descending', title: 'Typ absteigend'},
	{key: 'fromYear-asc', order: 'ascending', title: 'von Baujahr aufsteigend'},
	{key: 'fromYear-desc', order: 'descending', title: 'von Baujahr absteigend'},
	{key: 'tillYear-asc', order: 'ascending', title: 'bis Baujahr aufsteigend'},
	{key: 'tillYear-desc', order: 'descending', title: 'bis Baujahr absteigend'},
	{key: 'ps-asc', order: 'ascending', title: 'PS aufsteigend'},
	{key: 'ps-desc', order: 'descending', title: 'PS absteigend'},
	{key: 'ccm-asc', order: 'ascending', title: 'CCM aufsteigend'},
	{key: 'ccm-desc', order: 'descending', title: 'CCM absteigend'},
	{key: 'hours-asc', order: 'ascending', title: 'Stunden aufsteigend'},
	{key: 'hours-desc', order: 'descending', title: 'Stunden absteigend'},
	{key: 'price-asc', order: 'ascending', title: 'Preis aufsteigend'},
	{key: 'price-desc', order: 'descending', title: 'Preis absteigend'},
];
const searchOptions = [
	{key: 'tsn', text: 'TSN', value: 'tsn'},
	{key: 'hsn-tsn', text: 'HSN/TSN', value: 'hsn-tsn'},
	{key: 'type', text: 'Typbezeichnung', value: 'type'}
];


class ServiceKfzAssignment extends React.Component {
	static propTypes = {
		service_id: PropTypes.number.isRequired,
		kfz_id: PropTypes.number.isRequired,
		kfz: PropTypes.object,
		service: PropTypes.object,
		service_list: PropTypes.object,
		models: PropTypes.array,
		service_model_list: PropTypes.object.isRequired,
		onSaveModelStates: PropTypes.func.isRequired,
		onRemoveModelStates: PropTypes.func.isRequired,
		onBack: PropTypes.func
	};
	static defaultProps = {
		kfz: undefined,
		service: undefined,
		service_list: {},
		service_model_list: {},
		models: [],
		onSaveModelStates: () => alert('onSaveModelStates() is not implemented!'),
		onRemoveModelStates: () => alert('onRemoveModelStates() is not implemented')
	};
	
	state = {
		selected: {},
		workTimeVisible: false,
		sort: sortOptions[0].key,
		filterBy: searchOptions[0].key,
		filterText: '',
		hideAssigned: false,
		showDetailedFilters: false,
		showSelectionList: false,
		detailedFilters: DetailedFilters.DEFAULT_EXTENDED_FILTER,
		box: {
			width: 1000,
			height: 300
		}
	};
	
	udf = (d) => this.setState(state => ({
		...state,
		detailedFilters: {
			years: {
				...d.years,
			},
			ccm: {
				...d.ccm
			},
			ps: {
				...d.ps
			}
		}
	}));
	
	getKfz2Service = (service_id, kfz_id, obj=true) => {
		const {service_list} = this.props;
		return service_list[kfz_id] || (obj ? {service_id, kfz_id} : null);
	};
	
	translated = (service) => processData(service)(s => {
		s.translatedTitle = this.props.t([`service.name.service-${s.service_id}`, s.title]);
		s.isTranslated = s.translatedTitle !== s.title;
	});
	
	handleCheck = model => {
		const {selected} = this.state;
		if ( selected[model.model_id] ) {
			return this.setState(state => ({
				...state,
				selected: {
					...filterObj(state.selected)(m => m !== model.model_id)
				}
			}));
		}
		return this.setState(state => ({
			...state,
			selected: {
				...state.selected,
				[model.model_id]: model.model_id
			}
		}));
	};
	
	_getModeLPriceRelation = (model, ret=null) => {
		const {service_model_list} = this.props;
		if (service_model_list[model.model_id]) {
			return service_model_list[model.model_id];
		}
		return ret;
	};
	
	_getModelPrice = (model) => {
		const {service_list, kfz_id} = this.props;
		const rel = this._getModeLPriceRelation(model);
		if ( rel ) {
			const {price, hours_of_work} = rel;
			return <PriceInfo price={price} time={hours_of_work}/>
		}
		if ( service_list[kfz_id] ) {
			return 's. Fahrzeug';
		}
		return null;
	};
	
	sorted = () => {
		const {sort: current} = this.state;
		if ( !current ) {
			return sortDefault;
		}
		const _ = current.split('-');
		const order = _.pop();
		const key = _.join('-');
		switch(key) {
			case 'hsn-tsn': return sort(order)(m => m.hsn + m.tsn);
			case 'type': return sort(order)(m => m.type);
			case 'fromYear': return sortNum(order)(m => m.fromYear);
			case 'tillYear': return sortNum(order)(m => m.tillYear || 9999);
			case 'ps': return sortNum(order)(m => m.ps);
			case 'ccm': return sortNum(order)(m => m.ccm);
			case 'hours': return sortNum(order)(m =>
				tryable(() => this._getModeLPriceRelation(m).hours_of_work)(0)
			);
			case 'price': return sortNum(order)(m =>
				tryable(() => this._getModeLPriceRelation(m).price)(0)
			);
			default:
				return sortDefault;
		}
	};
	
	numberOfDetailedFilters = (extended=false) => {
		const {
			years, ccm, ps
		} = this.state.detailedFilters;
		let number = 0;
		const y = Number(isNum(years.from) || isNum(years.till));
		const c = Number(isNum(ccm.from) || isNum(ccm.till));
		const p = Number(isNum(ps.from) || isNum(ps.till));
		number += y + c + p;
		return extended ? [number, !!y, !!c, !!p] : number;
	};
	
	filterButtonName = () => {
		const number = this.numberOfDetailedFilters();
		return number ? ` Detailierte Filter (${number})` : ' Detailierte Filter';
	};
	
	filterAssigned = () => {
		const {hideAssigned} = this.state;
		if ( !hideAssigned ) {
			return () => true;
		}
		return m => this._getModeLPriceRelation(m, false) ? false : true;
	};
	
	filtered = () => {
		const {filterBy, filterText} = this.state;
		if ( filterText.trim() === '' ) {
			return compareDefault;
		}
		switch(filterBy) {
			case 'hsn-tsn': return compare(filterText, {fuzzy: false})(m => m.hsn + '/' + m.tsn);
			case 'tsn': return compare(filterText, {fuzzy: false})(m => m.tsn);
			case 'type': return compare(filterText)(m => m.type);
			default:
				return compareDefault;
		}
	};
	
	filteredExtended = () => {
		const [has, y, c, p] = this.numberOfDetailedFilters(true);
		if ( !has ) {
			return compareDefault;
		}
		const {
			years, ccm, ps
		} = this.state.detailedFilters;
		return m => {
			let hasYear = true, hasCcm = true, hasPs = true;
			if (y) {
				// years
				const {fromYear, tillYear = 9999} = m;
				if ( years.from !== '' ) {
					hasYear = years.from <= fromYear;
				}
				if (hasYear && years.till !== '') {
					hasYear = years.till >= tillYear;
				}
			}
			if (c) {
				// ccm
				if ( ccm.from !== '' ) {
					hasCcm = ccm.from <= m.ccm;
				}
				if (hasCcm && ccm.till !== '') {
					hasCcm = ccm.till >= m.ccm;
				}
			}
			if (p) {
				// ps
				if ( ps.from !== '' ) {
					hasPs = ps.from <= m.ps;
				}
				if ( hasPs && ps.till !== '' ) {
					hasPs = ps.till >= m.ps;
				}
			}
			return hasYear && hasCcm && hasPs;
		};
	};
	
	getModelLine = model => (
		<Subbar>
			<SubItem width={4/9}>{model.type}</SubItem>
			<SubItem width={1/9}>{model.fromYear} - {model.tillYear}</SubItem>
			<SubItem width={1/9}>{model.hsn}/{model.tsn}</SubItem>
			<SubItem width={2/9}>{model.ccm} ccm, {model.ps} ps</SubItem>
			<SubItem width={1/9}>{this._getModelPrice(model)}</SubItem>
		</Subbar>
	);
	
	render() {
		const {kfz, service: serviceData, models, kfz_id, onSaveModelStates, service_id, onRemoveModelStates, t, onBack} = this.props;
		
		if ( !kfz || !serviceData || !models.length ) {
			return <Placeholder repeat={3}/>
		}
		
		const service = this.translated(serviceData);
		const {selected: selectedModels, workTimeVisible, sort: sortMechanism, filterBy, filterText, hideAssigned, showDetailedFilters, showSelectionList, box} = this.state;
		const hasSelectedModels = !isEmpty(selectedModels);
		const visibleModels = models.filter(this.filterAssigned()).filter(this.filtered()).filter(this.filteredExtended()).sort(this.sorted());
		return(
			<Segment basic>
				<PageHeader>
					<Subbar>
						{onBack && <IconButton onClick={() => onBack()}>
							<Icon name={'chevron left'} size={'large'}/>
						</IconButton>}
						<Title as={'h2'}>
							{service.translatedTitle} für {kfz.name}
						</Title>
					</Subbar>
					<Popup content={`Arbeitszeiten für ${kfz.name} ${workTimeVisible ? 'ausblenden' : 'einblenden'}`} inverted position={'left center'} trigger={<IconButton onClick={() => this.setState({workTimeVisible: !workTimeVisible})}><Icon name={workTimeVisible ? 'minus square' : 'plus square'} size={'large'}/></IconButton>}/>
				</PageHeader>
				{workTimeVisible && <React.Fragment>
					<Segment basic>
						<WorkTimeController open={true} kfz2service={this.getKfz2Service(service.service_id, kfz.kfz_id)} onShowDetail={null}/>
					</Segment>
					<Divider/>
				</React.Fragment>}
				<Segment basic>
					<Subbar align={Subbar.ALIGN_BETWEEN}>
						<Subbar>
							<Button
								color={'black'}
								icon
								style={{whiteSpace: 'nowrap', marginRight: 10}}
								onClick={() => this.setState({showDetailedFilters: !showDetailedFilters})}>
								<Icon name={showDetailedFilters ? 'chevron up' : 'chevron down'}
							/>
								{this.filterButtonName()}
							</Button>
							<Checkbox
								style={{marginLeft: 10, whiteSpace: 'nowrap'}}
								label={'Zugewiesene ausblenden'}
								checked={hideAssigned}
								onCheck={() => this.setState({hideAssigned: !hideAssigned})}
								
							/>
						</Subbar>
						<Subbar style={{width: '100%'}} align={Subbar.ALIGN_END}>
							<Sortable
								value={sortMechanism}
								onChange={(_, key, value) => this.setState({sort: value})}
								options={sortOptions}
							/>
							<SearchFilter
								value={filterText}
								onChange={value => this.setState({filterText: value})}
								selected={filterBy}
								options={searchOptions}
								onSelect={value => this.setState({filterBy: value})}
							/>
							<span style={{whiteSpace: 'nowrap'}}>{models.length} Modelle gefunden</span>
							{hasSelectedModels &&
							<ButtonGroup style={{marginLeft: 10}}>
								<Popup content={'Auswahl aufheben'} inverted trigger={<Button icon color={'grey'} onClick={() => this.setState({selected: {}})}><Icon name={'close'}/></Button>}/>
								<Popup content={'Auswahl anzeigen'} position={'top center'} inverted trigger={<Button onClick={() => this.setState({showSelectionList: true})}>{Object.keys(selectedModels).length} Modelle gewählt</Button>}/>)
								<Button negative icon onClick={() => onRemoveModelStates(service_id, values(selectedModels), () => this.setState({selected: {}}))}><Icon name={'trash'}/> Auswahl löschen</Button>
							</ButtonGroup>
							}
						</Subbar>
					</Subbar>
					<DetailedFilters open={showDetailedFilters} onChange={detailedFilters => {
						console.info(detailedFilters);
						this.udf(detailedFilters)
					}}/>
					<Subbar style={{marginTop: 10}}>
						<ResizableBox
							width={box.width}
							height={box.height}
							onResize={(_, {size}) => this.setState({box: size})}
							style={{paddingRight: 10, paddingBottom: 10}}
							minConstraints={[700, 200]}
						>
							<VirtualList
								width={box.width - 10}
								height={box.height - 10}
								itemCount={visibleModels.length}
								itemSize={40}
								renderItem={({index, style}) => {
									const model = visibleModels[index];
									const isChecked = !!selectedModels[model.model_id];
									// const rel = this.getKfz2Service(service.service_id, kfz.kfz_id, false);
									return (
										<div key={model.model_id} onClick={() => this.handleCheck(model)} style={{
											...style,
											display: 'flex',
											cursor: 'pointer',
											flexDirection: 'column',
											justifyContent: 'center',
											borderBottom: '1px solid #ccc',
											background: isChecked ? COLOR_PRIMARY : 'transparent'
											// backgroundColor: showKfz && showKfz.kfz_id === kfz.kfz_id ? COLOR_PRIMARY : null
										}}>
											<Subbar align={Subbar.ALIGN_START} style={{padding: '0 10px'}}>
												<Checkbox
													checked={isChecked}
													// onCheck={(_, index, value) => this.handleCheck(model)}
													label={this.getModelLine(model)}
												/>
											</Subbar>
											{/*<Divider/>*/}
										</div>
									);
								}}
							/>
						</ResizableBox>
						<WorkTimeController
							style={{marginLeft: 25}}
							title={'Auswahl überschreiben'}
							extendedData={{list: values(selectedModels), kfz_id, service_id}}
							onSaveSuccess={() => this.setState({selected: {}})}
							onSave={onSaveModelStates}
							shouldClear={isEmpty(selectedModels)}
							onShowDetail={null}
							open={hasSelectedModels}
							kfz2service={{}}
						/>
						{!hasSelectedModels &&
							<Placeholder
								repeat={1}
								style={{width: 'auto', margin: 20, border: '1px solid #ccc', padding: 10, paddingTop: 30}}
								holderStyle={{transform: 'scale(0.8'}}
							/>
						}
					</Subbar>
				</Segment>
				<Modal size={'fullscreen'} basic open={showSelectionList} centered={false} onClose={() => this.setState({showSelectionList: false})}>
					<ModalHeader>Ausgewählte Modelltypen</ModalHeader>
					<ModalContent>
						<Table selectable={false} adjustForCheckbox={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn>Typ</TableHeaderColumn>
									<TableHeaderColumn>Baujahr</TableHeaderColumn>
									<TableHeaderColumn>HSN/TSN</TableHeaderColumn>
									<TableHeaderColumn>ccm</TableHeaderColumn>
									<TableHeaderColumn>PS</TableHeaderColumn>
									<TableHeaderColumn>Leistung</TableHeaderColumn>
									<TableHeaderColumn>Entfernen</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody displayRowCheckbox={false} showRowHover>
								{values(selectedModels).map(id => {
									const model = models.find(m => m.model_id === id);
									const {type, fromYear, tillYear, hsn, tsn, ccm, ps} = model || {};
									return (
										
										<TableRow key={`selected-modal-${model.model_id}`}>
											<TableRowColumn>{type}</TableRowColumn>
											<TableRowColumn>{fromYear} - {tillYear}</TableRowColumn>
											<TableRowColumn>{hsn}/{tsn}</TableRowColumn>
											<TableRowColumn>{ccm} ccm</TableRowColumn>
											<TableRowColumn>{ps} PS</TableRowColumn>
											<TableRowColumn>{this._getModelPrice(model)}</TableRowColumn>
											<TableRowColumn><IconButton onClick={() => this.handleCheck(model)}><Icon name={'trash'}/></IconButton></TableRowColumn>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</ModalContent>
					<ModalActions>
						<Button onClick={() => this.setState({showSelectionList: false})}>{t('actions.close')}</Button>
					</ModalActions>
				</Modal>
			</Segment>
		);
	}
}

export default translate()(ServiceKfzAssignment);


// WEBPACK FOOTER //
// ./src/components/ServiceKfzAssignment.js